import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { RouterListener } from './components/router-listener'
import React from 'react'

export const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => {
    return <div>Page not found</div>
  },
  InnerWrap(props) {
    return <RouterListener>{props.children}</RouterListener>
  }
})
